import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, emitirSegundaViaCrv } from './types';

export const INITIAL_STATE: emitirSegundaViaCrv = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): emitirSegundaViaCrv {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EMITIR_SEGUNDA_VIA_CRV_REQUEST: {
				break;
			}

			case Types.EMITIR_SEGUNDA_VIA_CRV_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}

			case Types.EMITIR_SEGUNDA_VIA_CRV_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EMITIR_SEGUNDA_VIA_CRV_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
